import { User } from './user.entity';
import { Position } from './position.entity';
import { Subscription } from './subscription.entity';
import { SimBrand } from './sim-brand.entity';

export class Tracker {
  id: number;

  imei: number;
  sim: string;

  type: string;
  name: string;
  firmware: string;
  need_upgrade: boolean;
  timezone: string;

  signature_pkey: string;

  mode: string;
  sensor_mode: string;
  freq_mode: string;

  sos_phone: string;

  area_appli_notification: boolean;
  area_mail_notification: boolean;
  area_sms_notification: boolean;

  sos_appli_notification: boolean;
  sos_mail_notification: boolean;
  sos_sms_notification: boolean;

  button_appli_notification: boolean;
  button_mail_notification: boolean;
  button_sms_notification: boolean;

  battery_appli_notification: boolean;
  battery_mail_notification: boolean;
  battery_sms_notification: boolean;

  force_subscription: boolean;
  had_subscription: boolean;

  enable_ai: boolean;
  enable_ai_spec: string;
  geofence_mode: string;
  spy_sos: boolean;
  call_directly: boolean;
  sos_mode: string;
  battery: number;
  retailer_id: number;
  retailer_name: string;

  features: string[];

  valid_signal: boolean;

  sales_data: {[key: string]: string | number};

  expiration_date: string;

  warranty_start: string;
  warranty_end: string;
  has_activity_tracking: Boolean;
  first_connection_date: string;
  activation_date: string;
  creation_date: string;

  position: Position[];

  user: User;

  subscription: Subscription;
  sim_brand: SimBrand;
  lot: string;
  model: string;
  tracker_color: string;

}



// WEBPACK FOOTER //
// /app/src/app/entities/tracker.entity.ts